if (!customElements.get('branding-community')) {
  customElements.define('branding-community', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const controller = new AbortController();
      const {signal} = controller;
      const grid = this.querySelector('.BrandCommunity__Grid');
      const controls = this.querySelector('.BrandCommunity__Controls');
      const previous = controls.querySelector('[data-community-prev]');
      const next = controls.querySelector('[data-community-next]');
      const counter = controls.querySelector('[data-community-count]');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const update = () => {
        const cards = [...grid.children];
        const rect = grid.getBoundingClientRect();
        const current = cards.map((card, index) => ({index, distance: Math.abs(card.getBoundingClientRect().left - rect.left)}))
          .reduce((nearest, card) => !nearest || card.distance < nearest.distance ? card : nearest, null);
        controls.hidden = grid.scrollWidth <= grid.clientWidth + 2;
        previous.disabled = grid.scrollLeft <= 2;
        next.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2;
        counter.textContent = current ? `${current.index + 1} / ${cards.length}` : '';
      };
      const move = direction => {
        const first = grid.firstElementChild;
        const step = first.getBoundingClientRect().width + parseFloat(getComputedStyle(grid).columnGap);
        grid.scrollBy({left: step * direction, behavior: reducedMotion.matches ? 'instant' : 'smooth'});
      };
      previous.addEventListener('click', () => move(-1), {signal});
      next.addEventListener('click', () => move(1), {signal});
      grid.addEventListener('scroll', update, {passive: true, signal});
      const observer = new ResizeObserver(update);
      observer.observe(grid);
      update();
      this.cleanup = () => {
        controller.abort();
        observer.disconnect();
        controls.hidden = true;
        this.cleanup = null;
      };
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}
